<template>
  <div class="container">
    <top-menu :current="['quote']"></top-menu>

    <div class="main-container">
      <section class="xsinfo-inquiry">
        <p class="xsinfo-inquiry-number">已有<span>43</span>位客户</p>
        <p class="xsinfo-inquiry-text">通过询价成功购得心仪的车辆</p>
      </section>
      <section class="xscarform mt-45">
        <!-- <h5 class="xscarform-subtit">
          留下您的信息，有特卖活动时我们将及时与您联系。
        </h5> -->
        <div class="dlr-formlist xscarform-formlist">
          <dl class="dlr-formlist-dl">
            <dd>
              <p class="dlr-form-name">购买品牌</p>
              <div class="dlr-form-card" @click="showBrands">
                <p
                  class="dlr-form-card car-series-txt"
                  v-if="cur_brand.name === ''"
                >
                  选择品牌
                </p>
                <p
                  class="dlr-form-card car-series-txt current"
                  v-if="cur_brand.name !== ''"
                >
                  {{ cur_brand.name }}
                </p>
              </div>
              <i class="dlr-icon24 icon24-right"></i>
            </dd>
            <dd>
              <p class="dlr-form-name">购买车系</p>
              <div class="dlr-form-card" @click="showSeries">
                <p
                  class="dlr-form-card car-series-txt"
                  v-if="cur_series.name === ''"
                >
                  选择车系
                </p>
                <p
                  class="dlr-form-card car-series-txt current"
                  v-if="cur_series.name !== ''"
                >
                  {{ cur_series.name }}
                </p>
              </div>
              <i class="dlr-icon24 icon24-right"></i>
            </dd>
            <dd>
              <p class="dlr-form-name">您的姓名</p>
              <div class="dlr-form-card">
                <input
                  type="text"
                  placeholder="请输入姓名"
                  value=""
                  name="username"
                  class="dlr-form-inptext"
                  v-model="name"
                />
                <p class="dlr-form-error fn-hide"></p>
              </div>
              <i
                class="dlr-icon24 icon24-cross icon-clear fn-hide"
                style="cursor: pointer"
              ></i>
            </dd>
            <dd>
              <p class="dlr-form-name">手机号码</p>
              <div class="dlr-form-card">
                <input
                  id="phoneNumber"
                  type="number"
                  placeholder="请输入手机号"
                  name="phoneNumber"
                  value=""
                  class="dlr-form-inptext"
                  v-model="phone"
                />
                <p class="dlr-form-error fn-hide"></p>
              </div>
              <i
                class="dlr-icon24 icon24-cross icon-clear fn-hide"
                style="cursor: pointer"
              ></i>
            </dd>
          </dl>
          <div class="dlr-formlist-link">
            <a
              href="javascript:void(0);"
              id="orderSubmit"
              class="dlr-btn dlr-btn-blue"
              @click="submit"
              >获取底价</a
            >
            <p class="dlr-form-explain">
              点击提交即视为同意<a
                href="javascript:void(0)"
                data-side-target="js-maskbottom-bhsm"
                class="color-blue"
                @click="centerDialogVisible = true"
                >《个人信息保护声明》</a
              >
            </p>
          </div>
        </div>
      </section>

      <a-drawer
        title="选择品牌"
        placement="right"
        :closable="true"
        :visible="brandVisible"
        :after-visible-change="afterVisibleChange"
        @close="onClose"
        :bodyStyle="{ padding: 0 }"
      >
        <div class="quote-brand-card" v-for="item in brands" :key="item.letter">
          <div class="quote-brand-card__letter">{{ item.letter }}</div>
          <ul>
            <li
              v-for="ite in item.brands"
              :key="ite.id"
              @click="chooseBrand(ite)"
            >
              <img :src="ite.logo_url" />
              <span> {{ ite.name }}</span>
            </li>
          </ul>
        </div>
      </a-drawer>

      <a-modal
        v-model="centerDialogVisible"
        title="《个人信息保护声明》"
        :footer="null"

      >
        拾成拾科技及其关联公司（如无特殊约定，以下统称“拾成拾”）收集用户的个人信息的最终目的是为了向您提供更好的产品、服务，优化并丰富您的用户体验。拾成拾将按照本声明的规定合理使用并保护用户的个人信息，据此制订《个人信息保护声明》如下：<br />
        <p>一、个人信息的收集</p>
        <p>
          1、拾成拾向用户收集的个人信息指的是能够单独或与其他信息结合识别您个人身份的信息，这些信息包括：①车型②联系方式③您在页面上留下的其他信息（车牌号、里程数、卖车意向等）④在您上载到网站的内容中包含的任何个人信息。
        </p>
        <p>
          2、以上个人信息均是用户自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用拾成拾提供的服务、产品，或者可能对您使用服务或产品造成一定的影响。
        </p>
        <p>
          3、对于不满18岁的用户，须在其法定监护人已经阅读本声明并且许可的情况下，通过网站提交个人信息。
        </p>
        <p>二、个人信息的使用</p>
        <p>
          1、我们会根据本声明为实现我们的产品与/或服务功能对所收集的个人信息进行使用。
        </p>
        <p>
          2、您同意，拾成拾可以通过以下方式对您个人信息进行使用和分享（包含对于个人信息的存储和处理）：
        </p>
        <p>（1）我们和关联公司使用；</p>
        <p>（2）我们向相关第三方服务商分享并由其使用；</p>
        <p>
          （3）我们及关联公司及相关第三方服务商为满足您的需求，可能通过您提供的信息与您联系；
        </p>
        <p>
          （4）我们及关联公司及相关第三方服务商可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息，您同意免除上述个人信息的接收和/或使用方在按照本法律声明所述情况下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。
        </p>
        <p>
          3、用户明确同意使用本平台服务的使用所存在的风险将完全由您自己承担，因用户使用拾成拾服务而产生的一切后果也由您自己承担，拾成拾对您不承担任何责任。
        </p>
        <p>三、联系我们</p>
        <p>
          如您对本声明或您个人信息的相关事宜有任何问题、意见或建议，您可随时拨打我们的客服电话：15117971875，或与我们的在线客服取得联系。
        </p>
      </a-modal>

      <a-drawer
        title="选择车系"
        placement="right"
        :closable="true"
        :visible="seriesVisible"
        :after-visible-change="afterVisibleChange"
        @close="onSeriesClose"
        :bodyStyle="{ padding: 0 }"
      >
        <div
          class="quote-brand-card"
          v-for="factory in series"
          :key="factory.factory_id"
        >
          <div class="quote-brand-card__letter">{{ factory.factory_name }}</div>
          <ul class="quote-series">
            <li
              v-for="series in factory.series"
              :key="series.id"
              @click="chooseSeries(series)"
            >
              <span> {{ series.name }}</span>
            </li>
          </ul>
        </div>
      </a-drawer>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";
import Footer from "@/components/Footer";
import { getBrands, getSeriesByBrandId } from "@/api/car";

export default {
  name: "Index",
  components: {
    TopMenu,
    Footer,
  },
  data() {
    return {
      brandVisible: false,
      seriesVisible: false,
      brands: [],
      series: [],
      cur_brand: {
        name: "",
        id: 0,
      },
      cur_series: {
        id: 0,
        name: "",
      },
      name: "",
      phone: "",
      centerDialogVisible: false,
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {
    console.log(this.$route.query.bname);
    if (this.$route.query.bname) {
      this.cur_brand.name = this.$route.query.bname;
    }
    if (this.$route.query.sname) {
      this.cur_series.name = this.$route.query.sname;
    }
    this.getBrandsData();
  },
  beforeDestroy() {},
  methods: {
    getBrandsData() {
      getBrands().then((resp) => {
        let letters = []; // 数据列表
        let brandMap = {}; // 每一个索引指向一个数组，这个数组存储该字母索引的朋友项
        resp.data.forEach((brand) => {
          const letter = brand.letter;
          brandMap[letter] || (brandMap[letter] = []);
          brandMap[letter].push(brand);
        });

        for (let letter in brandMap) {
          letters.push({
            letter: letter,
            brands: brandMap[letter],
          });
        }

        // 按首字母排序
        // 字符串比较不能用减号得出大小，返回都是NaN
        // 因此这里需要通过小于号比较
        letters.sort((a, b) => {
          return a.letter <= b.letter ? -1 : 1;
        });

        this.brands = letters;
      });
    },
    getSeriesData(id) {
      getSeriesByBrandId(id).then((resp) => {
        this.series = resp.data.series;
      });
    },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showBrands() {
      this.brandVisible = true;
    },
    showSeries() {
      if (this.cur_brand.id === 0) {
        this.$message.warning("请选择品牌");
        return false;
      }
      this.seriesVisible = true;
      this.getSeriesData(this.cur_brand.id);
    },
    onClose() {
      this.brandVisible = false;
    },
    chooseBrand(brand) {
      console.log(brand);
      this.cur_brand = brand;
      this.brandVisible = false;
    },
    chooseSeries(series) {
      console.log(series);
      this.cur_series = series;
      this.seriesVisible = false;
    },
    onSeriesClose() {
      this.seriesVisible = false;
    },
    submit() {
      console.log("sss");
      if (this.cur_brand.name === "") {
        this.$message.warning("请选择品牌");
        return;
      }
      if (this.cur_series.name === "") {
        this.$message.warning("请选择车系");
        return;
      }
      if (this.name === "") {
        this.$message.warning("请填写姓名");
        return;
      }
      if (this.phone === "") {
        this.$message.warning("请填写手机号");
        return;
      }

      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$message.warning("手机号格式错误");
        return;
      }

      var that = this;

      var timer = setTimeout(function () {
        that.$message.success("询价成功，稍后会有经销商与您联系！");
        clearTimeout(timer);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
}
.main-container {
  overflow: hidden;
  position: relative;
  transition: all 0.2s;

  top:100px;
  .xsinfo-inquiry {
    height: 5.8rem;
    background-size: 100%;
    padding: 0.95rem 0.75rem 1.85rem 0.75rem;
    text-align: center;
    color: #444;
  }
  .xscarform {
    background-color: #fff;
    margin: 0.75rem 0.75rem 0 0.75rem;
    border-radius: 0.15rem;
    position: relative;
    z-index: 1;
    padding: 0 0 0.25rem 0;
    border-radius: 0.15rem;
    .xscarform-subtit {
      height: 2.2rem;
      line-height: 2.2rem;
      padding: 0 0.75rem;
      font-size: 0.6rem;
      color: #999;
      position: relative;
    }
    .dlr-formlist {
      background-color: #fff;
      padding: 0 0.75rem;
      dd {
        position: relative;
        padding: 0.675rem 0.85rem 0.675rem 4.6rem;
        min-height: 2.475rem;
        line-height: 1.1rem;
        position: relative;
        .dlr-form-name {
          position: absolute;
          top: 0.675rem;
          left: 0;
          width: 4.6rem;
        }
        .dlr-form-card {
          position: relative;
          font-size: 14px;
          color: #ccc;
          .dlr-form-inptext {
            color: #666;
            font-size: 14px;
            width: 100%;
            border: 0;
            background: none;
            outline: none;
          }
          .current {
            color: #666;
          }
        }
        .dlr-icon24 {
          position: absolute;
          top: 1.2rem;
          right: 0;
          margin-top: -0.3rem;
        }
        .icon24-right {
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABTklEQVRIS7WVoU4DQRCGv7m6ukP3FdAE0UBAYSoq6hHXCXVYIBjAImmnfYOKiiYkKAIYQPMK9RdMHV2yyTUhJHe9a27P7mW+/f/Z+UcI/ElR/dFodCoiM1X93vYeuQAzOwfugTfgRFWX20ByAZPJpLVard6BFjCP47jb6/V+qkIKLTKzXeAViIGhqg5qBfhiZrYHPANN4EpV76pAChWsC43H445zbgY0gIGqDstCSgEyJWfAA/AjIt1+vz8vAykNyCCXwC3gX9SRqn5uglQCZBCvwqtJgQNV/SqCVAZMp9NGmqa+Hx1gEUXRfpIkizxIZUCmoumcexKRNuAVtPOmfWuAiDw65w5rBwS3yMzWTfYB6K2pr8lmdgH4SV5GUXScJMlHbc/UzMINWtCo+Bd216p6s8mWv+dl4voF2Kk9roMvnOAr0/sYdOlXaWTRv78D0pQZCcrhSwAAAABJRU5ErkJggg==)
            no-repeat center center;
          background-size: 0.6rem;
        }
      }
      .dlr-formlist-link {
        padding: 0.75rem 0;
        .dlr-btn-blue {
          display: block;
          width: 100%;
          height: 2.2rem;
          line-height: 2.2rem;
          background-color: #ea3434;
          color: #fff;
          font-size: 16px;
          -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
          text-align: center;
          border-radius: 0.1rem;
        }
        .dlr-form-explain {
          display: block;
          text-align: center;
          font-size: 0.7rem;
          color: #999;
          padding-top: 0.7rem;
        }
      }
    }
  }
}
.color-blue {
  color: #ea3434;
}

.quote-brand-card {
  .quote-brand-card__letter {
    position: relative;
    height: 1.5rem;
    margin: 0;
    padding: 0 0 0 0.5rem;
    font-size: 0.65rem;
    color: #333;
    line-height: 1.5rem;
    background-color: #f8f8f8;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;
    li {
      position: relative;
      padding: 0.25rem 0 0.25rem 0.5rem;
      img {
        float: left;
        width: 2.5rem;
        height: 2.5rem;
        margin: 0;
      }
      & > span {
        position: relative;
        display: block;
        height: 2.5rem;
        padding: 0;
        margin: 0 0 0 3.5rem;
        font-size: 0.8rem;
        color: #333;
        line-height: 2.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.quote-series {
  li {
    & > span {
      position: relative;
      display: block;
      padding: 0.95rem 0;
      margin: 0 0 0 0.5rem;
      font-size: 0.8rem;
      color: #333;
      line-height: 1.1rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>